var TagLink = class extends HTMLElement {
    constructor() {
      super();
  
      const href = this.querySelector("a").href
        let dataUrl = href.includes('?') ? href.substring(0, href.indexOf('?')) : href;
        dataUrl = dataUrl + '?view=filtered'

      const target = this.closest(this.dataset.container).querySelector(this.dataset.target)
      const tagWrapper = this.closest(".tags-wrapper")
      const loadMoreWrapper = this.closest(this.dataset.container).querySelector(".load-more-wrapper")
  
      this.querySelector("a").addEventListener("click", function(e){
        e.preventDefault();
        this.classList.add("loading")
  
        fetch(dataUrl).then(response => response.text()).then((responseText) => {
          const html = responseText;
          const htmlContent = new DOMParser().parseFromString(html, 'text/html')
  
          target.innerHTML = htmlContent.querySelector(this.dataset.target).innerHTML;
          tagWrapper.innerHTML = htmlContent.querySelector(".tags-wrapper").innerHTML || ""
          loadMoreWrapper.innerHTML = htmlContent.querySelector(".load-more-wrapper").innerHTML || ""
  
        })
      }.bind(this))
    }
  }
  
  customElements.define('tag-link', TagLink)

  var LoadMore = class extends HTMLElement {
    constructor() {
      super();
  
      this.dataUrl = this.dataset.url
      this.target = document.querySelector(this.dataset.target)
      this.loadMoreWrapper = this.closest("ul")
  
      this.addEventListener("click", function(e){
        e.preventDefault();
  
        this.closest('nav').classList.add("loading")
  
        fetch(this.dataUrl).then(response => response.text()).then((responseText) => {
          const html = responseText;
          const htmlContent = new DOMParser().parseFromString(html, 'text/html')
          this.replaceContent(htmlContent.querySelector(this.dataset.target).innerHTML)
          this.loadMoreWrapper.innerHTML = htmlContent.querySelector(".load-more-wrapper ul").innerHTML || ""  
        }).then(() => {
            // this.closest('nav').classList.remove("loading")
        })
      }.bind(this))
    }

    replaceContent(content) {
        this.target.innerHTML = this.target.innerHTML + content;
    }
  }
  
  window.customElements.define('load-more', LoadMore)

  var PaginationButton = class extends LoadMore {
    constructor() {
        super()
    }

    replaceContent(content) {
        this.target.innerHTML = content;
        this.target.scrollIntoView()
    }
  }

  window.customElements.define('pagination-button', PaginationButton)